import { render, staticRenderFns } from "./ApplicationAlerts.vue?vue&type=template&id=be4e9522&scoped=true&"
import script from "./ApplicationAlerts.vue?vue&type=script&lang=js&"
export * from "./ApplicationAlerts.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationAlerts.vue?vue&type=style&index=0&id=be4e9522&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4e9522",
  null
  
)

export default component.exports